import { LAYOUTS, } from "@voltmoney/types";
import { WIDGET } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { activatePledge, closeErrorModal, confirmAndGetOTP, goBackAction, needHelp, openKFSPage } from "./actions";
import { addCommasToNumber, getDateMonthYearFromEpoch, getLenderInfo } from "../../../configs/utils";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedPropsService from "../../../SharedPropsService";
export const template = (height, lenderData, pledgeDetails, selectedMutualFunds, selectedCreditLimit, autoDebitDate, assetPledgeFlow, loanExpireDateToShow, lenderId, processingFeeObject, processingChargesResponse) => ({
    layout: {
        id: ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: "verifyInterestEnhanceLimit",
                type: WIDGET.VERIFY_INTEREST_ENHANCE_LIMIT,
            },
        ],
    },
    datastore: {
        verifyInterestEnhanceLimit: {
            height: height,
            lenderData: lenderData,
            pledgeDetails: pledgeDetails,
            autoDebitDate: autoDebitDate,
            continueAction: {
                type: assetPledgeFlow ? ACTION.ACTIVATE_PLEDGE : ACTION.CONTINUE_AMOUNT_ASSETS,
                routeId: ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT,
                payload: { pledgeDetails }
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT,
                payload: {}
            },
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT,
                payload: {}
            },
            closeErrorModal: {
                type: ACTION.CLOSE_ERROR_MODAL,
                routeId: ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT,
                payload: {}
            },
            loanExpireDateToShow: loanExpireDateToShow,
            openKFSPage: {
                type: ACTION.OPEN_KFS_PAGE,
                routeId: ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT,
                payload: {}
            },
            lenderId: lenderId,
            showErrorModal: false,
            processingFeeObject: processingFeeObject,
            processingChargesResponse: processingChargesResponse
        }
    },
});
export const verifyInterestEnhanceLimitMF = {
    onLoad: async ({ getHeight, network }, { stepResponseObject }) => {
        const lenderData = await getLenderInfo(network);
        const userData = await SharedPropsService.getUser();
        let applicationId = '';
        if (await AsyncStorage.getItem('application_id')) {
            applicationId = await AsyncStorage.getItem('application_id');
        }
        else {
            applicationId = userData.linkedApplications[0].applicationId;
        }
        const lenderId = userData?.linkedCredits[0]?.lendingPartnerId;
        const pledgeDetails = await network.get(`${api.pledgeData}${applicationId}`, {
            headers: await getAppHeader()
        });
        const updateUser = await SharedPropsService.getUser();
        const assetPledgeFlow = "ASSET_PLEDGE" in updateUser.linkedApplications[0].stepStatusMap;
        const selectedMutualFunds = addCommasToNumber(Number(await SharedPropsService.getDesiredPortfolio()));
        const selectedCreditLimit = addCommasToNumber(await SharedPropsService.getCreditLimit());
        let loanExpireDateToShow = '';
        const autoDebitDate = lenderData?.lenderBusinessDetails?.autopayDate;
        const loanExpireDate = pledgeDetails?.data?.stepResponseObject?.loanEndDate;
        if (loanExpireDate !== null) {
            const loanDate = getDateMonthYearFromEpoch(loanExpireDate);
            loanExpireDateToShow = `${loanDate}`;
        }
        else {
            loanExpireDateToShow = '';
        }
        let mfPortfolioArray = [];
        let portfolioForComputingProcessingCharge;
        mfPortfolioArray = stepResponseObject
            ?.tobePledgedPortfolio;
        // eslint-disable-next-line prefer-const
        portfolioForComputingProcessingCharge = [...mfPortfolioArray];
        portfolioForComputingProcessingCharge?.push(...stepResponseObject?.pledgedPortfolio);
        const response = await network.post(api.processingCharges, {
            applicationId: applicationId,
            mutualFundPortfolioItems: portfolioForComputingProcessingCharge,
        }, { headers: await getAppHeader() });
        const processingFeeObject = response?.data?.stepResponseObject?.processingChargesBreakup;
        const processingChargesResponse = response?.data?.stepResponseObject;
        return Promise.resolve(template(getHeight(), lenderData, pledgeDetails.data, selectedMutualFunds, selectedCreditLimit, autoDebitDate, assetPledgeFlow, loanExpireDateToShow, lenderId, processingFeeObject, processingChargesResponse));
    },
    actions: {
        [ACTION.CONTINUE_AMOUNT_ASSETS]: confirmAndGetOTP,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.ACTIVATE_PLEDGE]: activatePledge,
        [ACTION.OPEN_KFS_PAGE]: openKFSPage,
        [ACTION.CLOSE_ERROR_MODAL]: closeErrorModal,
    },
};
